import React, { useReducer, useState } from "react";
import SendbirdProvider from "@sendbird/uikit-react/SendbirdProvider";
import { ChannelListProvider } from "@sendbird/uikit-react/ChannelList/context";
// import Chat from "./Chat";
import { ChannelProvider } from "@sendbird/uikit-react/Channel/context";

import { useEffect } from "react";
import utils from "../Utils";
import HttpClient from "../lib/HttpClient";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../components/layout/PageWrapper";
import Chat from "../components/chat/Chat";

interface ChatProviderMetadata {
  appId: string;
}

interface ChatData {
  sessionToken: string;
}

interface State {
  IS_LOADING: boolean;
  IS_ERROR: boolean;
  IS_LOADED: boolean;
  data?: {
    chatProviderMetadata: ChatProviderMetadata;
    chatData: ChatData;
  };
}

interface Action {
  type: "LOADED" | "LOADING" | "ERROR";
  payload?: {
    appData?: ChatProviderMetadata;
    data?: ChatData;
  };
}

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "LOADED":
      return {
        IS_LOADING: false,
        IS_ERROR: false,
        IS_LOADED: true,
        data: {
          chatProviderMetadata: action.payload?.appData!,
          chatData: action.payload?.data!,
        },
      };
    case "LOADING":
      return {
        IS_LOADING: true,
        IS_ERROR: false,
        IS_LOADED: false,
        data: undefined,
      };
    case "ERROR":
      return {
        IS_LOADING: false,
        IS_ERROR: true,
        IS_LOADED: false,
        data: undefined,
      };
    default:
      return state;
  }
};

const initialState = {
  IS_LOADING: true,
  IS_ERROR: false,
  IS_LOADED: false,
  data: undefined,
};

export const ChatPage = () => {
  const profile = utils.retrieveUserProfile();
  const navigate = useNavigate();

  const [channel, setChannel] = useState<{ _url: string } | null>(null);

  const [state, dispatch] = useReducer(reducer, initialState);

  const initChat = async () => {
    dispatch({ type: "LOADING" });
    const URL = `/api/v1/chat/init?admin=true`;
    try {
      const response = await HttpClient.performPut<any>(URL);

      response.body.status?.success
        ? dispatch({ type: "LOADED", payload: response.body })
        : dispatch({ type: "ERROR" });

      // if( data?.status?.success&&data.data.channels.length>0){
      //       setChannel(data?.data?.channels[0])

      // }
    } catch (e) {
      dispatch({ type: "ERROR" });
    }
  };

  useEffect(() => {
    initChat();
  }, []);

  return (
    <PageWrapper>
      {state.IS_LOADING ? (
        <div
          className="mainContentCointainer"
          style={{
            margin: "20px",
            marginTop: "100px",
            height: "85vh",
            width: "96vw",
            backgroundColor: "#FFFFFF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "row",
          }}
        >
          <Spinner />
        </div>
      ) : state.IS_LOADED ? (
        <SendbirdProvider
          appId={state?.data?.chatProviderMetadata?.appId || ""} // Specify your Sendbird application ID.
          userId={profile.clinicId}
          accessToken={state?.data?.chatData?.sessionToken} // Specify your user ID.
        >
          {console.log(state, "state")}
          <ChannelListProvider>
            <ChannelProvider channelUrl={channel ? channel._url : ""}>
              <Chat
                channel={channel}
                setChannel={setChannel}
                data={state.data?.chatData}
                profile={profile.clinicId}
                accessToken={state?.data?.chatData?.sessionToken}
                appId={state?.data?.chatProviderMetadata?.appId}
              />
            </ChannelProvider>
          </ChannelListProvider>
        </SendbirdProvider>
      ) : (
        <div
          className="mainContentCointainer"
          style={{
            margin: "20px",
            marginTop: "100px",
            height: "85vh",
            width: "96vw",
            backgroundColor: "#FFFFFF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "row",
          }}
        >
          Something went wrong
        </div>
      )}
    </PageWrapper>
  );
};
